export let hrms27uColumns = () => {
  let indexColumns = [{
    key: 'dteappoi',
    name: '',
    labelCodapp: 'HRMS27UC1',
    labelIndex: '140',
    class: 'align-center',
    style: 'min-width: 200px;',
    inlineType: 'date',
    eventName: 'dteappoi',
    validateRules: 'date_format:DD/MM/YYYY',
    dataType: 'date'
  }, {
    key: 'numappl',
    name: '',
    labelCodapp: 'HRMS27UC1',
    labelIndex: '40',
    class: 'align-center',
    style: 'min-width: 100px;',
    eventName: 'numappl'
  }, {
    key: 'desc_numappl',
    name: '',
    labelCodapp: 'HRMS27UC1',
    labelIndex: '50',
    style: 'min-width: 150px;'
  }, {
    key: 'desc_codpos',
    name: '',
    labelCodapp: 'HRMS27UC1',
    labelIndex: '70',
    style: 'min-width: 200px;'
  }, {
    key: 'numreql',
    name: '',
    labelCodapp: 'HRMS27UC1',
    labelIndex: '90',
    class: 'align-center',
    style: 'min-width: 100px;',
    eventName: 'numreql'
  }, {
    key: 'emprcname',
    name: '',
    labelCodapp: 'HRMS27UC1',
    labelIndex: '130',
    style: 'min-width: 150px;'
  }]

  return {
    en: {
      index: indexColumns
    },
    th: {
      index: indexColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hrms27u.js